import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ClaimRecordStatus } from '@typesApp/ClaimRecord'
import { EligibleProductStatus } from '@typesApp/Product'
import { closeApp } from '@redux/slices/workflowSlice'
import { activeClaimPerformedSelector, claimRecordStatusSelector, eligibleProductStatusSelector } from '@redux/slices/claimStatusSlice'
import { usePageFlow } from '@hooks/usePageFlow'
import { usePathBuilder } from '@hooks/usePathBuilder'
import { useAppNavigate } from '@hooks/useAppNavigate'
import { LoadingSkeleton } from './LoadingSkeleton'

export const LoginRedirect: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useAppNavigate()
  const buildPath = usePathBuilder()
  const { loginRedirectView, isReady } = usePageFlow()
  const claimRecordStatus = useSelector(claimRecordStatusSelector)
  const productStatus = useSelector(eligibleProductStatusSelector)
  const isActiveClaimChecked = useSelector(activeClaimPerformedSelector)

  useEffect(() => {
    if (!isActiveClaimChecked) return

    if (productStatus === EligibleProductStatus.NOT_ELIGIBLE || claimRecordStatus === ClaimRecordStatus.RESTRICTED) {
      dispatch(closeApp())
    } else if (isReady && productStatus === EligibleProductStatus.ELIGIBLE) {
      navigate(buildPath(loginRedirectView))
    }
  }, [dispatch, navigate, productStatus, claimRecordStatus, isReady, isActiveClaimChecked])

  return (
    <LoadingSkeleton />
  )
}